const getters = {
  sidebar: state => state.app.sidebar,
  token: state => state.user.token,
  username: state => state.user.username,
  userId: state => state.user.userId,
  addRouters: state => state.permission.addRouters,
  modules: state => state.permission.modules,
  priv: state => state.permission.priv,
  errorLogs: state => state.errorLog.logs
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js